<ui-form [label]="label" [required]="required" [formGroup]="formGroup" class="datepicker">
  <div class="datepicker-group">
    <input
      [value]="value"
      (blur)="onTouched()"
      [formControlName]="formControlName"
      type="text"
      id="datepicker"
      name="datepicker"
      formInput
      #input
      (focus)="input.blur()"
      [bsConfig]="bsConfig"
      bsDaterangepicker
    />
    <div class="date-view" [class.date-placeholder]="!value" (click)="input.click()">
      <span class="date-from">
        {{ value ? dateFrom : ('GA.HOTEL_FORM.CHECK_IN' | translate) }}
      </span>
      <svg-icon src="/assets/icons/icons-calendar-alt.svg"></svg-icon>
      <span class="date-to">
        {{ value ? dateTo : ('GA.HOTEL_FORM.CHECK_OUT' | translate) }}
      </span>
    </div>
  </div>
</ui-form>
